import http from "../http-common";

class LiveExamService {
  // ============ USER ============
  getActiveLiveExams() {
    return http.get("/live-exams");
  }

  getOverview() {
    return http.get("/live-exams/overview");
  }

  getMyRegistrations() {
    return http.get("/live-exams/my-registrations");
  }

  getLiveExamDetails(id) {
    return http.get(`/live-exams/${id}`);
  }

  register(id) {
    return http.post(`/live-exams/${id}/register`);
  }

  submitAttempt(id, wpm, accuracy, errorPercentage) {
    return http.post(`/live-exams/${id}/submit`, { wpm, accuracy, errorPercentage });
  }

  getLeaderboard(id, limit = 1000) {
    return http.get(`/live-exams/${id}/leaderboard?limit=${limit}`);
  }

  // ============ ADMIN ============
  getAllLiveExams() {
    return http.get("/live-exams/admin/all");
  }

  createLiveExam(data) {
    return http.post("/live-exams/admin/create", data);
  }

  updateLiveExam(id, data) {
    return http.put(`/live-exams/admin/${id}`, data);
  }

  deleteLiveExam(id) {
    return http.delete(`/live-exams/admin/${id}`);
  }

  forceStart(id) {
    return http.post(`/live-exams/admin/${id}/start`);
  }

  createTelegramDraft(id) {
    return http.post(`/live-exams/admin/${id}/telegram-draft`);
  }

  sendTelegramNow(id) {
    return http.post(`/live-exams/admin/${id}/telegram-send`);
  }

  startAndSendTelegram(id) {
    return http.post(`/live-exams/admin/${id}/start-and-telegram`);
  }

  forceEnd(id) {
    return http.post(`/live-exams/admin/${id}/end`);
  }
}

const liveExamService = new LiveExamService();
export default liveExamService;

